import PdpBenefitsController from '@/pdp-braun/Controllers/PdpBenefitsController';
import PdpColorsController from '@/pdp-braun/Controllers/PdpColorsController';
import PdpCompareCarouselController from '@/pdp-braun/Controllers/PdpCompareCarouselController';
import PdpGalleryController from '@/pdp-braun/Controllers/PdpGalleryController';
import PdpRecipesController from '@/pdp-braun/Controllers/PdpRecipesController';
import PdpReviewsController from '@/pdp-braun/Controllers/PdpReviewsController';
import PdpSimilarCarouselController from '@/pdp-braun/Controllers/PdpSimilarCarouselController';
import PdpStickyMenuController from '@/pdp-braun/Controllers/PdpStickyMenuController';
import PdpVariantsSelectorController from '@/pdp-braun/Controllers/PdpVariantsSelectorController';
import { initSingleInlineBVReview } from '@/utils/Controllers/Bazaarvoice/BVZeroReviewsController';
import GTMComparisonTool from '@/utils/Controllers/GTM/Operations/ComparisonTool';
import { emitGtmListingImpression } from '@/utils/Controllers/GTM/Operations/ListingImpression';
import PdpFaqsController from '@/utils/Controllers/PdpFaqsController';
import PdpInfosPopupController from '@/utils/Controllers/PdpInfosPopupController';

document.addEventListener('DOMContentLoaded', () => {
  PdpBenefitsController();
  PdpReviewsController();
  PdpCompareCarouselController();
  PdpGalleryController();
  PdpColorsController();
  PdpStickyMenuController();
  PdpInfosPopupController();
  PdpRecipesController();
  GTMComparisonTool();
  initSingleInlineBVReview(document.querySelector('.js-bv-wrapper-inline'));
  emitGtmListingImpression();
  PdpSimilarCarouselController();
  PdpFaqsController();
  PdpVariantsSelectorController();
});
